import { useRequest } from 'domain/core/hooks/useRequest';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';

export const useResendEmail = (): any => {
  const { isLoading, error, send, status } = useRequest({
    url: '/api/v1/auth/resendEmail',
    method: ApiMethodsEnum.Post,
    sendOnStart: false,
    body: {},
  });

  const resendEmail = (body: { email: string }) => {
    const { email } = body;
    if (email) {
      send({ ...body });
    }
  };

  if (!error && status === 204) {
    return {
      isLoading,
      error,
      send: resendEmail,
    };
  }

  return {
    isLoading,
    error,
    send: resendEmail,
  };
};
